import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";

export default function HeroSearch() {
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("");
  const [city, setCity] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (category) params.set("category", category);
    if (city) params.set("city", city);
    navigate(`/directory?${params.toString()}`);
  };

  return (
    <form
      onSubmit={submit}
      className="grid w-full gap-3 rounded-2xl border border-white/40 bg-white/95 p-3 shadow-[0_24px_60px_rgba(9,49,46,0.25)] backdrop-blur md:grid-cols-[1.5fr_1fr_1fr_auto]"
      data-testid="hero-search-form"
    >
      <label className="flex items-center gap-2 rounded-lg bg-sand/60 px-3 py-2.5">
        <Search className="h-4 w-4 text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search providers, practices, services…"
          className="w-full bg-transparent text-[15px] outline-none placeholder:text-muted-foreground"
          data-testid="hero-search-q"
        />
      </label>
      <label className="flex items-center gap-2 rounded-lg bg-sand/60 px-3 py-2.5">
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="w-full appearance-none bg-transparent text-[15px] text-foreground outline-none"
          data-testid="hero-search-category"
        >
          <option value="">All categories</option>
          {CATEGORIES.map((c) => (
            <option key={c.name} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>
      </label>
      <label className="flex items-center gap-2 rounded-lg bg-sand/60 px-3 py-2.5">
        <MapPin className="h-4 w-4 text-muted-foreground" />
        <input
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="City (Denver, Aurora…)"
          className="w-full bg-transparent text-[15px] outline-none placeholder:text-muted-foreground"
          data-testid="hero-search-city"
        />
      </label>
      <button type="submit" className="btn-accent" data-testid="hero-search-submit">
        Search
      </button>
    </form>
  );
}
